import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingOverlay, useAlert } from '../../components';
import { redeemGiftCode } from '../../services/firestoreService';
import { formatCurrency } from '../../utils/helpers';
import './GiftCodeScreen.css';

export const GiftCodeScreen = () => {
    const navigate = useNavigate();
    const { refreshUserData } = useAuth();
    const alert = useAlert();
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleRedeem = async () => {
        if (!code.trim()) {
            alert.showError('Error', 'Please enter a voucher code');
            return;
        }

        setLoading(true);
        try {
            const amount = await redeemGiftCode(code.trim());
            await refreshUserData();
            alert.showSuccess(
                'Congratulations!',
                `You received ${formatCurrency(amount)} bonus!`,
                () => {
                    setCode('');
                    navigate(-1);
                }
            );
        } catch (error) {
            alert.showError('Error', error.message || 'Invalid or expired gift code');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="gift-code-screen-modern">
            <div className="gift-header-nav">
                <button className="back-btn-gift" onClick={() => navigate(-1)}>
                    <span className="material-icons">arrow_back</span>
                </button>
                <h1 className="gift-title-nav">GIFT CODE</h1>
            </div>

            <div className="gift-content-area">
                <div className="gift-hero-section">
                    <div className="gift-main-icon-box">
                        <span className="material-icons">card_giftcard</span>
                    </div>
                    <h2 className="gift-hero-title">REDEEM VOUCHER</h2>
                    <p className="gift-hero-subtitle">ENTER CODE TO RECEIVE INSTANT CASH REWARDS</p>
                </div>

                <div className="gift-redeem-form">
                    <input
                        type="text"
                        className="gift-code-input"
                        placeholder="N X T - X X X X"
                        value={code}
                        onChange={(e) => setCode(e.target.value.toUpperCase())}
                    />

                    <button
                        className="collect-reward-btn"
                        onClick={handleRedeem}
                        disabled={loading || !code.trim()}
                    >
                        {loading ? 'REDEEMING...' : 'COLLECT REWARD'}
                    </button>
                </div>

                <div className="redemption-rules-card">
                    <h3 className="rules-title">REDEMPTION RULES:</h3>
                    <div className="rules-list">
                        <div className="rule-item">
                            <span className="material-icons check-icon">check</span>
                            <span className="rule-text">One code can only be used once per account.</span>
                        </div>
                        <div className="rule-item">
                            <span className="material-icons check-icon">check</span>
                            <span className="rule-text">Rewards are credited instantly to your wallet.</span>
                        </div>
                        <div className="rule-item">
                            <span className="material-icons check-icon">check</span>
                            <span className="rule-text">Join Official Channel for daily limited codes.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GiftCodeScreen;
